import { Panel } from "@/dom/components/Panel/Panel";
import { PanelBody } from "@/dom/components/Panel/PanelBody";
import { PanelHeader } from "@/dom/components/Panel/PanelHeader";
import React, { useMemo } from "react";
import { RoomSizeSection } from "./RoomSizeSection";
import { RoomStyleSection } from "./RoomStyleSection";
import { useDemoState } from "@/state/demoState";
import { SELECTED_ITEM_TYPE } from "@/3d/SelectedItem";
import { isWallKey } from "@/state/RoomConfig/RoomConfig";
import { Button } from "@/dom/components/Button/Button";
import { PanelFooter } from "@/dom/components/Panel/PanelFooter";
import { WallPropsSections } from "./WallPropsSections";
import { WallSizeSection } from "./WallSizeSection";
import { WallStyleSection } from "./WallStyleSection";

export const RoomSetup: React.FC = () => {
    const selectedItem = useDemoState((state) => state.selectedItem);
    const setSelectedItem = useDemoState((state) => state.setSelectedItem);
    const nextStep = useDemoState((state) => state.nextStep);

    const handleBack = () => {
        setSelectedItem(undefined);
    };

    const wallKey = useMemo(() => {
        if (selectedItem?.selectedItemType === SELECTED_ITEM_TYPE.WALL) {
            const key = selectedItem.key;
            if (isWallKey(key)) {
                return key;
            }
        }

        if (selectedItem?.selectedItemType === SELECTED_ITEM_TYPE.WALL_PROP) {
            const key = selectedItem.parent;
            if (key && isWallKey(key)) {
                return key;
            }
        }

        return undefined;
    }, [selectedItem]);

    const handleSaveAndSelectFurniture = () => {
        nextStep();
    };

    if (wallKey) {
        return (
            <Panel>
                <PanelHeader title="Настройка стены" onBack={handleBack} />
                <PanelBody>
                    <WallSizeSection wallKey={wallKey} />
                    <WallStyleSection wallKey={wallKey} />
                    <WallPropsSections wallKey={wallKey} />
                </PanelBody>
                <PanelFooter>
                    <Button onClick={handleSaveAndSelectFurniture}>
                        Сохранить и выбрать мебель
                    </Button>
                </PanelFooter>
            </Panel>
        );
    }

    return (
        <Panel>
            <PanelHeader title="Создайте комнату" />
            <PanelBody>
                <RoomSizeSection />
                <RoomStyleSection />
            </PanelBody>
            <PanelFooter>
                <Button onClick={handleSaveAndSelectFurniture}>Сохранить и выбрать мебель</Button>
            </PanelFooter>
        </Panel>
    );
};
